import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import _ from 'underscore';

import { AppState } from '../../../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../../../app/utils/ConnectUtils';
import { createNewContentInfoRequest } from '../../../actions/ContentExplorerCreateActions';
import { OrderedCreateContentActions } from './CreateContentActionsList';
import {
  CreateContentButton,
  CreateContentButtonDispatchProps,
  CreateContentButtonInfo,
  CreateContentButtonOwnProps,
  CreateContentButtonStateProps,
} from './CreateContentButton';

export const mapStateToProps: MapStateToProps<CreateContentButtonStateProps, CreateContentButtonOwnProps> = (state: AppState, ownProps: CreateContentButtonOwnProps) => {
  const createButtons: CreateContentButtonInfo[] = OrderedCreateContentActions
    .filter((action => action.isVisible(state, ownProps.spaceType, ownProps.location)))
    .map((action) => {
      return {
        contentType: action.contentType,
        title: action.title(ownProps.spaceType),
        icon: action.icon,
        disabled: !action.isClickable(state, ownProps.projectId),
        isDivider: action.isDivider
      };
    });

  return { createContentButtons: createButtons };
};

export const mapDispatchToProps: MapDispatchToProps<CreateContentButtonDispatchProps> = (dispatch: Dispatch<AppState>) => ({
  requestCreateContentButtonsInfo: () => {
    // Ensure all needed data is in the store
    dispatch(createNewContentInfoRequest());
  },
  createContent: (contentType: string, projectId: string) => {
    const createContentAction = _.find(OrderedCreateContentActions, a => a.contentType === contentType);
    const reduxAction = createContentAction.createReduxAction(projectId);
    dispatch(reduxAction);
  }
});

export const ConnectedCreateContentButton: React.ComponentClass<CreateContentButtonOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(CreateContentButton);
